














import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { PlanList } from '@/prioritization/interface/interface';

import { profile } from '@/Utils/profile';
const ieslabDisableRules = profile.get('ieslabDisableRules') === 'true';

/**
 * @author guan
 * @description
 */
@Component({
    components: {},
})
export default class FinanceBar extends Vue {
    /** disabledFunction */
    disabledFunction = ieslabDisableRules;
    /** */
    @Prop(Boolean)
    flag!: boolean;

    /** 相对计划列表 */
    @Prop({ default: () => [] })
    relatedPlanList!: PlanList[];

    /**
     *
     */
    @Emit('export-to-file')
    exportToFile(): void {
        return;
    }

    /**
     *
     */
    @Emit('start-calculate')
    startCalculate(): void {
        return;
    }

    /**
     * @author guan
     * @description 点击对比方案
     * @return void
     */
    compare(): void {
        this.$emit('compare');
    }

    /**
     * 初始化
     */
    mounted(): void {
        this.disabledFunction = ieslabDisableRules;
    }
}
